var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightRainShower01 = function SvgLightRainShower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light_rain_shower-01_svg2__a",
    x1: 6.96,
    x2: 172.99,
    y1: 171.67,
    y2: 16.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#light_rain_shower-01_svg2__a",
    id: "light_rain_shower-01_svg2__b",
    x1: 40.38,
    x2: 206.4,
    y1: 207.35,
    y2: 51.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#light_rain_shower-01_svg2__a",
    id: "light_rain_shower-01_svg2__c",
    x1: 57.86,
    x2: 223.88,
    y1: 226.01,
    y2: 70.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#light_rain_shower-01_svg2__a",
    id: "light_rain_shower-01_svg2__d",
    x1: 75.33,
    x2: 241.36,
    y1: 244.67,
    y2: 89.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#light_rain_shower-01_svg2__a",
    id: "light_rain_shower-01_svg2__e",
    x1: 12.66,
    x2: 178.69,
    y1: 177.76,
    y2: 22.27
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#light_rain_shower-01_svg2__a",
    id: "light_rain_shower-01_svg2__f",
    x1: 29.94,
    x2: 195.96,
    y1: 196.2,
    y2: 40.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#light_rain_shower-01_svg2__a",
    id: "light_rain_shower-01_svg2__g",
    x1: 47.21,
    x2: 213.24,
    y1: 214.65,
    y2: 59.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#light_rain_shower-01_svg2__a",
    id: "light_rain_shower-01_svg2__h",
    x1: 64.49,
    x2: 230.51,
    y1: 233.09,
    y2: 77.61
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M154.9 32.98c-3.37 0-6.82.46-10.46 1.39-8.89-19.38-27.91-31.71-49.37-31.71-23.78 0-44.62 15.22-51.87 37.86-.66 2.05.47 4.24 2.52 4.89 2.06.66 4.24-.47 4.89-2.52 6.21-19.41 24.08-32.45 44.46-32.45 18.11 0 34.18 10.26 41.94 26.44-5.35 2.44-9.04 6.05-11.31 8.93a3.896 3.896 0 0 0 .65 5.47c.71.56 1.56.84 2.41.84 1.15 0 2.29-.51 3.06-1.48 2.11-2.67 5.81-6.2 11.46-7.82.02 0 .11-.03.13-.04 4.15-1.35 7.91-2.01 11.5-2.01 20.57 0 37.31 16.74 37.31 37.31s-16.74 37.31-37.31 37.31H35.89c-15.5 0-28.1-12.61-28.1-28.1s12.61-28.1 28.1-28.1c2.29 0 4.68.37 7.52 1.17 3.73 1.12 7.18 3.14 9.74 5.68.76.76 1.75 1.13 2.75 1.13s2-.38 2.76-1.15a3.89 3.89 0 0 0-.02-5.51c-3.45-3.44-8.08-6.14-13.01-7.63h-.04c-.01 0-.02-.01-.03-.02-3.57-1-6.64-1.47-9.67-1.47C16.1 51.39 0 67.49 0 87.29s16.1 35.89 35.89 35.89H154.9c24.87 0 45.1-20.23 45.1-45.1s-20.23-45.1-45.1-45.1",
    style: {
      fill: "url(#light_rain_shower-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.94 196.29 14.4-14.4a3.61 3.61 0 0 0 0-5.09 3.61 3.61 0 0 0-5.09 0l-14.4 14.4a3.61 3.61 0 0 0 0 5.09 3.61 3.61 0 0 0 5.09 0",
    style: {
      fillRule: "evenodd",
      fill: "url(#light_rain_shower-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.34 196.29 14.4-14.4a3.61 3.61 0 0 0 0-5.09 3.61 3.61 0 0 0-5.09 0l-14.4 14.4a3.61 3.61 0 0 0 0 5.09 3.61 3.61 0 0 0 5.09 0",
    style: {
      fill: "url(#light_rain_shower-01_svg2__c)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.75 196.29 14.4-14.4a3.61 3.61 0 0 0 0-5.09 3.61 3.61 0 0 0-5.09 0l-14.4 14.4a3.61 3.61 0 0 0 0 5.09 3.61 3.61 0 0 0 5.09 0",
    style: {
      fillRule: "evenodd",
      fill: "url(#light_rain_shower-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.89 157.64 14.4-14.4a3.61 3.61 0 0 0 0-5.09 3.61 3.61 0 0 0-5.09 0l-14.4 14.4a3.61 3.61 0 0 0 0 5.09 3.61 3.61 0 0 0 5.09 0",
    style: {
      fillRule: "evenodd",
      fill: "url(#light_rain_shower-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.86 157.64 14.4-14.4a3.61 3.61 0 0 0 0-5.09 3.61 3.61 0 0 0-5.09 0l-14.4 14.4a3.61 3.61 0 0 0 0 5.09 3.61 3.61 0 0 0 5.09 0",
    style: {
      fillRule: "evenodd",
      fill: "url(#light_rain_shower-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.83 157.64 14.4-14.4a3.61 3.61 0 0 0 0-5.09 3.61 3.61 0 0 0-5.09 0l-14.4 14.4a3.61 3.61 0 0 0 0 5.09 3.61 3.61 0 0 0 5.09 0",
    style: {
      fillRule: "evenodd",
      fill: "url(#light_rain_shower-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.8 157.64 14.4-14.4a3.61 3.61 0 0 0 0-5.09 3.61 3.61 0 0 0-5.09 0l-14.4 14.4a3.61 3.61 0 0 0 0 5.09 3.61 3.61 0 0 0 5.09 0",
    style: {
      fillRule: "evenodd",
      fill: "url(#light_rain_shower-01_svg2__h)"
    }
  }));
};
export default SvgLightRainShower01;